const styles = getComputedStyle(document.documentElement);
const xs = styles.getPropertyValue('--breakpoint-xs');
const sm = styles.getPropertyValue('--breakpoint-sm');
const md = styles.getPropertyValue('--breakpoint-md');
const lg = styles.getPropertyValue('--breakpoint-lg');
const xl = styles.getPropertyValue('--breakpoint-xl');

const pixelBreakpoints = {
  xs,
  sm,
  md,
  lg,
  xl,
};

const unitlessBreakpoints = {};
Object.entries(pixelBreakpoints).forEach(([key, val]) => {
  unitlessBreakpoints[key] = parseInt(val.replace('px', ''));
});

export { pixelBreakpoints, unitlessBreakpoints };
